import { Navigate } from "react-router-dom";
const Protected = ({ accessIsLogIn, children }) => {
    console.log('protected',accessIsLogIn);
if (!accessIsLogIn || accessIsLogIn===null) {
return <Navigate to="/" replace />;
}
return children;
};
export default Protected;